import React from 'react';
import './Estilos.style.scss'
import CONFIG_IMG from '../images/config.png'
import ovni from '../images/ovni.png'
const Header = (props) => {
    return (
        <div style={{ backgroundColor: '#561574', padding: '6px' }} class="container">
            <a onClick={props.onClick}>
                <img style={{ marginBottom: '-50px', width: "30px" }} src={CONFIG_IMG} width="30" />
            </a>
            <a class="row justify-content-center" href="extr">
                <img style={{ width: "90px", margin: "16px" }} src={"https://extraperrestres.com/wp-content/uploads/2021/06/cropped-logo-extraperrestres.jpeg"} />
            </a>
            <div class="row text-center">
                <p style={{ color: 'white' }}> @extraperrestres</p>
            </div>
        </div>
        // <div style={{flex:1 }}>
        //     <div style={{ height: '20px', backgroundColor:'#561574' }}>

        //     </div>
        //     <div className="center" style={{ backgroundColor: 'white', paddingTop: '10px' }}>
        //         <img src={window.location.origin + '/extraperrestres.png'} width="60" />
        //         <p style={{ textAlign: 'center' }}> @extraperrestres</p>
        //     </div>
        // </div>
    )
}
export default Header;